import React from 'react';
import styled from 'styled-components';

const FooterStyled = styled.footer`
  grid-area: footer;
  color: #444;
  margin-top: 0.3rem;
`;

const Footer = () => (
  <FooterStyled>© NAGASHIMA Koki {new Date().getFullYear()}</FooterStyled>
);

export default Footer;
